<template>
    <div>
        <div id="mainhold">
            <div id="leftcolumn" class="cols">
                <div v-for="(list, index) in ardoc" v-bind:key='index'>
                    <div class="listingholder">
                        <div class="imgHolder" :style="{ 'background-image': `url(${list.metaIMG})`}"></div>
                        <div class="wrapper amTealregular">{{list.document_Id}}</div>
                        <div class="btn bgTeal cpointer" v-if="!list.arReady" @click="openArtwork(list, 'leftcolumn')">open</div>
                        <div class="btn bgGray cpointer" v-if="list.arReady">DONE</div>
                    </div>
                </div>
            </div>
            <div id="rightcolumn" class="cols">
                <div v-if="!ifUploaded">
                <div class="imgHolder2" :style="{ 'background-image': `url(${artwork.mainURL})`}" @click="openImage(artwork.mainURL)"></div>
                <div class="wrapper amTealregular">Dimensions H {{artwork.length}} x W {{artwork.width}}</div>
                <div class="btn bgTeal cpointer" @click="viewPost(artwork.document_Id)">VIEW POST</div>
                <input type="file" ref="fileInput">
                <div class="btn bgMint cpointer" @click="submitFile(artwork.document_Id)">upload</div>
                <div class="btn bgPink cpointer" @click="submitUpdate(artwork.document_Id, artwork.mainURL)">ready as is</div>
                </div>
                <div v-if="ifUploaded">
                    <div class="wrapper amTealregular">Uploaded</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../main'
import { resizeImage } from "../utils";
import firebase from 'firebase/app';
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/storage'
export default {
    name: "arReady",
    data(){
        return {
            ardoc: [],
            artwork: {},
            userID: "",
            imgBlob: "",
            ifUploaded: false,
            arlink: "",
            uploadValue: null,
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                this.userID = firebase.auth().currentUser.uid
                this.fetchArtworks()
            }
        })
    },
    methods: {
        submitUpdate(artid, imgURL){
            const datatransfer = ({
                imgURL: imgURL,
                postID: artid
            })
            const upIMG = firebase.functions().httpsCallable('arReady')
            upIMG(datatransfer).then(result => {
                if (result){
                    this.ifUploaded = true

                }
            })
        },
        submitFile(artid){
            const input = this.$refs.fileInput;
            const files = input.files;
            if (files && files[0]){
                resizeImage({
                    file: files[0],
                    sizes: [600]
                }).then(({blobs}) => {
                    this.imgBlob = blobs[0]
                    // console.log(this.imgBlob)
                    const fileref = artid + '_arIMG' + ".jpg";

                    if (this.imgBlob !== undefined){
                        const storageRef = firebase.storage().ref().child('museoArtistFeed').child(fileref).put(this.imgBlob);
                        storageRef.on(`state_changed`, snapshot => {
                            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, error => {
                            alert(error.message);
                        }, () => {
                            this.uploadValue = 100;
                            storageRef.snapshot.ref.getDownloadURL().then(arimg => {
                              const arData = ({
                                  arimg: arimg,
                                  postID: artid
                              })
                             const upIMG = firebase.functions().httpsCallable('arUpdate')
                             upIMG(arData).then(result => {
                                 if (result){
                                     this.ifUploaded = true
                                 }
                             })
                            })
                        })
                    }
                    
                })
            }
        },
        scrollTop(element){
                setTimeout(() => {
                    document.getElementById(element).scrollIntoView();
                },20)
            },
        viewPost(postid){
            const openPost = "https://artmuseo.com/art/?artworkID=" + postid
            // console.log(openPost, "This is the url link")
      window.open(openPost, "_blank");
        },
        openArtwork(artwork, element){
            this.artwork = artwork
            this.scrollTop(element)
            this.ifUploaded = false
        },
        openImage(artworkimage){
            const openPost = artworkimage
            window.open(openPost, "_blank");
        },
        fetchArtworks(){
            this.ardoc = []
            db.collection('posts').where('postType', '==', 'artwork').where('visible', '==', true).where('arReady', '==', false).get().then(docs => {
                if (docs){
                    docs.forEach(doc => {
                        const artwork = doc.data()
                        this.ardoc.push(artwork)
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
#mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    position: relative;
}

.cpointer {
    cursor: pointer;
}

.btn {
    width: auto;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float:right;
    clear: right;
}

#rightcol {
    width: auto;
    height: auto;
    position: fixed;
    top: 0;
    margin-top: 300px;
    right: 0;
    margin-left: 50vw;
}

.imgHolder {
    width: 50px;
    height: 50px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.imgHolder2 {
    width: 250px;
    height: 250px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.wrapper {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: right;
    margin-left: 20px;
}

.wrapperr {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: left;
    margin-left: 20px;
}

.listingholder {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 2%;
    margin-bottom: 5px;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
    overflow: scroll;
}
</style>